export const LANDING_PAGE_PUBLIC_DATA_URL = "/api/homepage/public";
export const LANDING_PAGE_AUTHENTICATED_DATA_URL = "/api/homepage";
